import { PageKey } from "../enums/pages"
import { HEADER_VARIANTS } from "../enums/variants"
import { RouteConfig } from "../types/routes"

type Routes = Partial<Record<PageKey, RouteConfig>>

export const ROUTES_APP: Routes = {
  HOME: { headerVariant: HEADER_VARIANTS.HUGE, path: "/" },
  ATELIERS: {
    headerVariant: HEADER_VARIANTS.DEFAULT,
    path: "/ateliers",
  },
  STYLEGUIDE: {
    headerVariant: HEADER_VARIANTS.DEFAULT,
    path: "/styleguide",
  },
  MATERIEL: {
    headerVariant: HEADER_VARIANTS.DEFAULT,
    path: "/materiel",
  },
  OUTILS: {
    headerVariant: HEADER_VARIANTS.DEFAULT,
    path: "/outils",
  },
  BLOG: {
    headerVariant: HEADER_VARIANTS.DEFAULT,
    path: "/blog",
  },
}

export const ROUTES_ATELIERS: Routes = {
  ATELIER_LECTURE_FLASH: {
    headerVariant: HEADER_VARIANTS.MINIMAL,
    path: `${ROUTES_APP.ATELIERS.path}/lecture-flash`,
    label: "Lecture Flash",
    description: "Un atelier qui affiche des mots",
  },
  ATELIER_ENQUETE_NOEL: {
    headerVariant: HEADER_VARIANTS.MINIMAL,
    path: `${ROUTES_APP.ATELIERS.path}/enquete-noel`,
    label: "L'enquête de Noel",
    description: "Une enquête givrée !",
  },
  ATELIER_DETECTIVE_CLUX_HALLOWEEN: {
    headerVariant: HEADER_VARIANTS.MINIMAL,
    path: `${ROUTES_APP.ATELIERS.path}/detective-clux-halloween`,
    label: "Les enquêtes du Détective Clux : Mystère au château pour Halloween",
    description:
      "Trouve le coupable, l'objet dérobé et le lieu où il est caché !",
  },
}

export const ROUTES: Routes = {
  ...ROUTES_APP,
  ...ROUTES_ATELIERS,
}
